import "./OrthodonticTreatments.module.css";
import Header from "@/reusable_sections/Header";
import HeroWelcomeToMotormtaaConnect from "./sections/HeroWelcomeToMotormtaaConnect";
import TechnologyExecution from "./sections/TechnologyExecution";
import CustomCakesGallery from "./sections/CustomCakesGallery";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function OrthodonticTreatmentsPage() {
  return <div>
      <Header />
      <HeroWelcomeToMotormtaaConnect />
      <TechnologyExecution />
      <CustomCakesGallery />
      <Projects />
      <Footer />
    </div>;
}